import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { UseResource } from '../../utils/types';

type ProvidersOutput = TrpcOutputs['getProviders'][1];
type UseProviders = UseResource<ProvidersOutput, never, never> & {
  count?: number;
  refetch: () => void;
};

export const useProviders = (queryParams: TrpcInputs['getProviders']): UseProviders => {
  const { isLoading, data, error, refetch } = trpc.getProviders.useQuery(queryParams, {
    refetchOnWindowFocus: false,
  });

  const itemCount = data?.[0];
  const items = data?.[1];

  return {
    data: items,
    count: itemCount,
    isLoading,
    error: error?.message,
    refetch,
  };
};
